import { EditorState, convertFromRaw, SelectionState, Modifier } from 'draft-js';
import decorator from './decorator';

export const resolveInserts = (editorState, fieldInserts) => {
    const eState = EditorState.createWithContent(convertFromRaw(editorState), decorator);

    let contentState = eState.getCurrentContent();
    const selectionsToReplace = getSelectionsToReplace(eState, fieldInserts);

    selectionsToReplace.forEach(({ blockSelection, replacementText }) => {
        contentState = Modifier.replaceText(
            contentState,
            blockSelection,
            replacementText
        );
    });

    return EditorState.createWithContent(contentState, decorator);
};

function getSelectionsToReplace (editorState, fieldInserts) {
    const blockMap = editorState.getCurrentContent().getBlockMap();

    return blockMap.reduce((selectionsToReplace, contentBlock) => {
        let offsets = [];
        fieldInserts.forEach(insert => {
            find(insert.match, contentBlock, (start, end) => {
                if (offsets.length) {
                    offsets.forEach(offset => {
                        if (start >= offset.start) {
                            start -= offset.length;
                            end -= offset.length;
                        }
                    });
                }
                const blockKey = contentBlock.getKey();
                const blockSelection = SelectionState
                    .createEmpty(blockKey)
                    .merge({
                        anchorOffset: start,
                        focusOffset: end
                    });
                offsets.push({
                    start: end,
                    length: insert.match.length - insert.data.length
                });
                selectionsToReplace.push({
                    blockSelection,
                    replacementText: insert.data
                });
            });
        });
        return selectionsToReplace;
    }, []);
}

function find (search, block, callback) {
    const text = block.getText();
    const searchRegEx = new RegExp(search, 'gi');
    let match;
    while ((match = searchRegEx.exec(text)) !== null) {
        const start = match.index;
        callback(start, start + match[0].length);
    }
}
